import { gql } from '@apollo/client';

export const ORDER_INFO = gql`
  query getOrderInfo($orderId: ID!, $country: CountryCode!)
  @inContext(country: $country) {
    node(id: $orderId) {
      ... on Order {
        id
        name
        fulfillmentStatus
        successfulFulfillments {
          trackingCompany
          trackingInfo {
            number
            url
          }
          fulfillmentLineItems(first: 250) {
            edges {
              node {
                lineItem {
                  title
                  variant {
                    id
                    title
                    image {
                      originalSrc
                    }
                    product {
                      handle
                    }
                    selectedOptions {
                      name
                      value
                    }
                  }
                }
              }
            }
          }
        }
        financialStatus
        processedAt
        canceledAt
        currencyCode
        totalPriceV2 {
          amount
        }
        shippingAddress {
          id
          firstName
          lastName
        }
        lineItems(first: 250) {
          edges {
            node {
              title
              variant {
                id
                title
                image {
                  originalSrc
                  altText
                }
                product {
                  handle
                }
                selectedOptions {
                  name
                  value
                }
              }
            }
          }
        }
      }
    }
  }
`;

export default {};
